module.exports = __webpack_public_path__ + "static/media/document.f73d267a.svg";